import React, { forwardRef } from 'react';
import { Suspense } from 'react';

import Loader from './Loader';

// Loadable - Lazy loading support
// eslint-disable-next-line react/display-name
const Loadable = (Component) => forwardRef((props, ref) => (
  <Suspense fallback={<Loader />}>
    <Component {...props} ref={ref} />
  </Suspense>
));

export default Loadable;
